<script setup>
import { computed } from 'vue'
import { usePortalStore } from '@/stores/portal.store'
import { useUnitOfMeasureService } from '@/services/unit.of.measure.service'
import DocumentRowStockInfo from '@/components/shared/DocumentRowStockInfo.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  preview: {
    type: Object,
    required: true,
  },
  documentType: {
    type: Number,
    required: true,
  },
  positionEditable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['position-changed'])

const portalStore = usePortalStore()
const { getConversionRatio } = useUnitOfMeasureService()
const isTransfer = computed(() => props.documentType === portalStore.documentTypesEnum.WAREHOUSE_TRANSFER)

const changes = computed(() => {
  if (!props.preview.hasProduct || props.preview.confirmed) return {}

  const quantity = Number(props.preview.quantity)
  if (!Number.isFinite(quantity) || quantity <= 0) return {}

  const { unitOfMeasureRef, productUnitOfMeasureRef, supplierBrandRef } = props.preview
  const requiresConversion = unitOfMeasureRef && productUnitOfMeasureRef && unitOfMeasureRef !== productUnitOfMeasureRef
  const ratio = requiresConversion ? getConversionRatio(unitOfMeasureRef, productUnitOfMeasureRef, supplierBrandRef) : 1
  const stockQuantity = Number((quantity * ratio).toFixed(3))
  const delta = props.documentType === portalStore.documentTypesEnum.WAREHOUSE_LOAD ? stockQuantity : -stockQuantity

  return {
    stock: delta,
    theoreticalStock: delta,
    ...(isTransfer.value ? { stock_secondary: stockQuantity, theoreticalStock_secondary: stockQuantity } : {}),
  }
})
</script>

<template>
  <document-row-stock-info
    :data="props.data"
    :changes="changes"
    :show-secondary="isTransfer"
    :position-editable="props.positionEditable"
    missing-as-zero
    @position-changed="value => emit('position-changed', value)"
  />
</template>
